export default __webpack_public_path__ + "static/pu-coating-571b3faa112bf342a7b17b6b49062142.png";